import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

type Props = {
	hasError: boolean
	isDisabled: boolean
	isFocus: boolean
	isFocusVisible: boolean
	isHovered: boolean
	isReadOnly: boolean
	isSmall?: boolean
}

export const InputContainer = styled.div<Props>`
	cursor: ${({ isDisabled, isReadOnly }) => (isDisabled || isReadOnly ? 'auto' : 'text')};
	display: flex;
	justify-content: space-between;
	column-gap: 8px;
	background-color: ${({ isHovered, isFocusVisible, isDisabled, isFocus, isReadOnly, hasError }) => {
		if (isDisabled) return helpers.color.input.backgroundDisabled
		if (isReadOnly) return helpers.color.input.backgroundReadOnly
		if (isHovered || isFocusVisible || isFocus)
			return hasError ? helpers.color.input.backgroundErrorHover : helpers.color.input.backgroundHover
		return hasError ? helpers.color.input.backgroundError : helpers.color.input.background
	}};
	border: 1px ${({ isReadOnly }) => (isReadOnly ? 'dashed' : 'solid')} ${({
		isHovered,
		isFocusVisible,
		isFocus,
		isDisabled,
		isReadOnly,
		hasError,
	}) => {
		if ((isHovered || isFocusVisible || isFocus) && !(isDisabled || isReadOnly))
			return hasError ? helpers.color.input.borderError : helpers.color.input.borderHover
		return hasError ? helpers.color.input.borderError : helpers.color.input.border
	}};
	border-radius: 4px;
	box-shadow: ${({ isFocusVisible, hasError, isDisabled, isReadOnly }) => {
		if (isFocusVisible && !(isDisabled || isReadOnly))
			return hasError
				? `0 0 0 2px ${helpers.color.input.borderOutlineError} `
				: `0 0 0 1px ${helpers.color.input.borderOutlineHover}`
		return 'none'
	}};
	color: ${({ isReadOnly, isDisabled }) => {
		if (isReadOnly || isDisabled) return helpers.color.input.contentDisabled
		return helpers.color.input.content
	}};
	font-family: ${helpers.font.family.base};
	font-size: ${({ isSmall = false }) => (isSmall ? '14px' : '15px')};
	line-height: 1.2;
	margin: 0 0 -5px;
	outline: 0;
	padding: ${({ isSmall = false }) => (isSmall ? '4px 6px' : '10px 6px')};
	position: relative;
	text-align: left;
	transition: border 135ms ease, box-shadow 135ms ease, background-color 135ms ease;
	width: 100%;
	min-height: 20px;
`
